import { Ref, MutableRefObject } from "react";

export const mergeRefs = <T>(...refs: (Ref<T> | undefined)[]) => {
  return (element: T | null) => {
    refs.forEach((ref) => {
      if (!ref) return;
      if (typeof ref === "function") {
        ref(element);
      } else if (ref && "current" in ref) {
        (ref as MutableRefObject<T | null>).current = element;
      }
    });
  };
};
